import PropTypes from "prop-types";
import { Empty, Image } from "antd";

const TripRecordImages = ({ images, emptyDescription }) => {
    if (!images.length) {
        return (
            <Empty
                description={emptyDescription}
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                className="py-4"
            />
        );
    }

    return (
        <div className="flex flex-wrap gap-2">
            <Image.PreviewGroup>
                {images.map((imageUrl, index) => (
                    <Image
                        key={`${imageUrl}-${index}`}
                        src={imageUrl}
                        alt={`Photo ${index + 1}`}
                        width={72}
                        height={72}
                        className="!rounded-xl !border !border-[#f0f0f0] object-cover"
                        preview
                    />
                ))}
            </Image.PreviewGroup>
        </div>
    );
};

TripRecordImages.propTypes = {
    images: PropTypes.arrayOf(PropTypes.string).isRequired,
    emptyDescription: PropTypes.string.isRequired,
};

export default TripRecordImages;
